// extracted by mini-css-extract-plugin
export default {"container":"uZ-z","list":"vZ-z"};